import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Mytrips from "./pages/myTrips";
import Drivers from "./pages/drivers";
import Cabs from "./pages/cabs";
import PermitHolders from "./pages/permitHolders";
import Franchises from "./pages/franchises";
import Users from "./pages/users";
import ForgotPassword from "./pages/forgot-password";
import Login from "./pages/login";
import SsoLogin from "./pages/sso-login";
import SsoLogout from "./pages/sso-logout";
import Profile from "./components/dashboard/EditItemsFromTable/profileEdit";
import PermitHolderEdit from "./components/dashboard/EditItemsFromTable/permitHolderEdit";
import FranchiseEdit from "./components/dashboard/EditItemsFromTable/franchiseEdit";
import { PrivateRoute } from "./functions/privateRoutes";
import Permit from "./pages/permit";
import UserEdit from "./components/dashboard/EditItemsFromTable/userEdit";
import DriverEdit from "./components/dashboard/EditItemsFromTable/driverEdit";
import CabEdit from "./components/dashboard/EditItemsFromTable/cabEdit";
import Logout from "./pages/logout";
import Settings from "./pages/settings";
import Accounting from "./pages/accounting";
import Regions from "./pages/regions";
import Shifts from "./pages/shifts";
import Heatmap from "./pages/heatmap";
import Map from "./pages/map";
import HomeLocation from "./pages/homeLocation";
import Messages from "./pages/messages";
import PreOrders from "./pages/preorders";
import UploadFilesComponent from "./pages/invoiceFileInput";
import SummaryPage from "./pages/invoiceSummary";
import { FilledInput } from "@material-ui/core";
import MobileDashboard from "./pages/mobile/dashboard";
import MobileMyTrips from "./pages/mobile/myTrips";
import MobileShifts from "./pages/mobile/shifts";

const Routes = () => {
  return (
    <>
      <Route path="/forgot-password">
        <ForgotPassword />
      </Route>
      <Switch>
        <PrivateRoute exact path="/">
          <Dashboard />
        </PrivateRoute>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/sso-login">
          <SsoLogin />
        </Route>
        <Route path="/sso-logout">
          <SsoLogout />
        </Route>
        <Route path="/myTrips">
          <Mytrips />
        </Route>
        <Route path="/drivers">
          <Drivers />
        </Route>
        <Route path="/cabs">
          <Cabs />
        </Route>
        <Route path="/permitHolders">
          <PermitHolders />
        </Route>
        <Route path="/franchises">
          <Franchises />
        </Route>
        <Route path="/users">
          <Users />
        </Route>
        <Route path="/dashboard">
          <Dashboard />
        </Route>
        {/* <Route path="/profile">
        <Profile/>
      </Route> */}
        <Route path="/permitHolderEdit/:id">
          <PermitHolderEdit />
        </Route>
        <Route path="/franchiseEdit/:id">
          <FranchiseEdit />
        </Route>
        <Route path="/permit/:id/:permitHolderId">
          <Permit />
        </Route>
        <Route path="/userEdit/:id">
          <UserEdit />
        </Route>
        <Route path="/driverEdit/:id">
          <DriverEdit />
        </Route>
        <Route path="/homeLocation/:id/:driverId">
          <HomeLocation />
        </Route>
        <Route path="/cabEdit/:id">
          <CabEdit />
        </Route>
        <Route path="/logout">
          <Logout />
        </Route>
        <Route path="/settings">
          <Settings />
        </Route>
        <Route path="/accounting">
          <Accounting />
        </Route>
        <Route path="/regions">
          <Regions />
        </Route>
        <Route path="/shifts">
          <Shifts />
        </Route>
        <Route path="/heatmap">
          <Heatmap />
        </Route>
        <Route path="/map">
          <Map />
        </Route>
        <Route path="/messages">
          <Messages />
        </Route>
        <Route path="/preorders">
          <PreOrders />
        </Route>
        <Route path="/invoiceGenerator">
          <UploadFilesComponent />
        </Route>
        <Route path="/summary">
          <SummaryPage />
        </Route>
        <Route path="/callback">
          <SummaryPage></SummaryPage>
        </Route>
        <Route path="/mobile/dashboard">
          <MobileDashboard />
        </Route>
        <Route path="/mobile/myTrips">
          <MobileMyTrips />
        </Route>
        <Route path="/mobile/shifts">
          <MobileShifts />
        </Route>
      </Switch>
    </>
  );
};
export default Routes;
